export function storeQuery ({
	keys = [
		"utm_source",
		"utm_medium",
		"utm_campaign",
		"utm_content",
		"fbclid",
		"gclid",
	],
	additionalKeys = [],
	storageKey = "trackingParams",
	storage = window.localStorage,
	url = window.location.href,
	ttl,
} = {}) {
	const query = new URL(url).searchParams;
	const allKeys = keys.concat(additionalKeys || []);
	const toStore = {};
	try {
		let hasSome = false;
		allKeys.forEach(key => {
			if (query.has(key)) {
				hasSome = true;
				toStore[key] = query.get(key);
			}
		});
		if (hasSome) {
			if (ttl) {
				toStore.$expire = Date.now() + ttl;
			}
			storage[storageKey] = JSON.stringify(toStore);
		}
	}
	catch {}
}

export function getStoredQuery ({
	storageKey = "trackingParams",
	storage = window.localStorage,
} = {}) {
	try {
		const storedQuery = JSON.parse(storage[storageKey] || "{}");
		if (storedQuery.$expire && storedQuery.$expire <= Date.now()) {
			delete storage[storageKey];
			return {};
		}
	}
	catch {
		return {};
	}
}
